var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar-(2)-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 8.03131C12.298 8.03131 12 8.3306 12 8.69924L12 14.0431C12 14.4111 11.7013 14.711 11.3334 14.711L2 14.711C1.63196 14.711 1.33337 14.4111 1.33337 14.0431L1.33337 4.69141C1.33337 4.32339 1.63196 4.02348 2 4.02348L7.33337 4.02348C7.70203 4.02348 8 3.72419 8 3.35555C8 2.98679 7.70203 2.6875 7.33337 2.6875L2 2.6875C0.897339 2.6875 0 3.58659 0 4.69141L0 14.0431C0 15.1479 0.897339 16.047 2 16.047L11.3334 16.047C12.436 16.047 13.3334 15.1479 13.3334 14.0431L13.3334 8.69924C13.3334 8.32987 13.0353 8.03131 12.6666 8.03131L12.6666 8.03131Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25075 7.4217C6.20412 7.46842 6.17275 7.52786 6.15944 7.59195L5.68813 9.95399C5.66616 10.0635 5.70082 10.1763 5.77944 10.2558C5.84279 10.3193 5.92812 10.3533 6.01552 10.3533C6.03676 10.3533 6.05886 10.3514 6.08083 10.3467L8.43752 9.87449C8.50283 9.86103 8.56215 9.82972 8.60817 9.78288L13.8828 4.4979L11.5261 2.13672L6.25075 7.4217Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5117 0.504097C14.8618 -0.147199 13.8044 -0.147199 13.155 0.504097L12.2324 1.42851L14.5891 3.78981L15.5117 2.86528C15.8264 2.5507 15.9998 2.13118 15.9998 1.68499C15.9998 1.23881 15.8264 0.819288 15.5117 0.504097L15.5117 0.504097Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/editGreen.817f3e00467a67288efbc6b34d4eb47c.svg";
export { ForwardRef as ReactComponent };